import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosError} from 'axios';
import {message} from 'antd';

import {axiosRequest} from '../../helpers/request';
import {IindustryState, IRequestError} from './industry-slice-types';

export const getIndustry = createAsyncThunk<
    string[],
    undefined,
    {rejectValue: IRequestError}
>(
    "INDUSTRY/LIST", async (_, thunkApi) => {
        try {
            const config = {headers: {"Content-Type": "application/json"}};
            const res = await axiosRequest.get(`/compliance/get-business-type`, config);
            return res.data;
        } 
        catch (err:any) {
            let error: AxiosError<IRequestError> = err;
            if(!error.response){
                throw err;
            }
            return thunkApi.rejectWithValue(error.response.data)
        }
    }
);

const industrySlice = createSlice({
    name: 'industry',
    initialState: {
        industryStatus: 'idle',
        industries: [],
    } as IindustryState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getIndustry.pending, (state, _) => {
            state.industryStatus = 'pending';
        })
        builder.addCase(getIndustry.fulfilled, (state, {payload}) => {
            state.industries = payload;
            state.industryStatus = 'succeeded';
        })
        builder.addCase(getIndustry.rejected, (state, {payload, error}) => {
            state.industries = [];
            state.industryStatus = 'failed';
            if(payload?.detail){
                message.error(payload.detail);
            }else{
                message.error(error.message)
            }
        })
    },
});

export default industrySlice.reducer;
